import * as lang_1033 from './Language/lang_1033';
import * as lang_10 from './Language/lang_10';
import * as lang_21 from './Language/lang_21';
import * as lang_1042 from './Language/lang_1042';
import * as lang_17 from './Language/lang_17';

const getStaticTextDiagnose = lang => {
    switch (lang) {
        case '1033':
            return lang_1033;
        case '10':
            return lang_10;
        case '21':
            return lang_21;
        case '1042':
            return lang_1042;
        case '17':
            return lang_17;
        default:
            return lang_1033;
    }
};
export default getStaticTextDiagnose;
